export const ElementDimensions = {
    deviceIndependentBuffer: 200,
    appBarHeight: 57,
    logoHeight: 30,
    progressBarHeight: 60,
    footerBarHeightWithLogo: 120,
    footerBarHeight: 80,
    footerBarHeightLandscape: 80,
    footerBarHeightPaymentScreen: 80,
    footerBarHeightReceiptScreen: 50,
    dialogBarHeight: 50,
    headerBarHeight: 40,
    toggleButtonHeight: 50,
    stepperHeight: 65,
    fullScreenDialogHeaderHeight: 100,
    landscapeBarWidth: 100,
    landscapeViewWidth: 100,
    padding5: 5,    
    padding10: 10,    
    padding15: 15,    
    padding20: 20,
    padding30: 30,
    padding40: 40,
    padding50: 40,
    margin2: 2,    
    margin5: 5,    
    margin10: 10,    
    margin20: 20,
    margin30: 30,
    margin40: 40,
    margin50: 50,
}